
export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Diagnose',
      description: 'Map workflows, identify bottlenecks, audit data flows',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Design',
      description: 'Architect AI-assisted systems tailored to operational realities',
      icon: 'ri-draft-line'
    },
    {
      number: '03',
      title: 'Implement',
      description: 'Deploy workflows and integrations with minimal disruption',
      icon: 'ri-settings-3-line'
    },
    {
      number: '04',
      title: 'Optimize',
      description: 'Continuously refine systems using performance insights',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            How We Create Operational Clarity
          </h2>
        </div>

        <div className="relative">
          {/* Connector Line */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-0.5 bg-gray-300" style={{ width: 'calc(100% - 160px)', left: '80px' }}></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col items-center text-center">
                  {/* Icon Circle */}
                  <div className="w-16 h-16 flex items-center justify-center bg-white border-2 border-blue-500 rounded-full mb-6 relative z-10">
                    <i className={`${step.icon} text-2xl text-blue-500`}></i>
                  </div>

                  {/* Step Number */}
                  <div className="text-xs font-mono text-gray-400 mb-2">{step.number}</div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
